import { Pipe, PipeTransform } from '@angular/core';
import { IAirPortTranslated } from '../../components/popular-airlines/models/airlineInfo.models';
//this pipe take an argument as the input and return a filterd array wich include the search input
@Pipe({
  name: 'filterCity',
})
export class FilterCityPipe implements PipeTransform {
  transform(value: IAirPortTranslated[] | null | undefined, args: string, lang: 'ar' | 'en'): IAirPortTranslated[] {
    if (!Array.isArray(value)) {
      console.warn('FilterCityPipe received a non-array value:', value);
      return [];
    }

    if (!args?.trim()) {
      return value;
    }

    let result: IAirPortTranslated[] = [];
    for (let element of value) {
      let a = element[lang].cityName.toLowerCase();
      let b = element[lang].airportCode.toLowerCase();
      let c = element[lang].airportName.toLowerCase();

      if (
        a.startsWith(args.toLowerCase()) ||
        b.startsWith(args.toLowerCase()) ||
        c.startsWith(args.toLowerCase())
      ) {
        result.push(element);
      }
    }

    return result;
  }
}
